import React, { useEffect, useState } from "react";
import { Spin, Button, DatePicker } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { TabComponent, TabItemDirective, TabItemsDirective } from '@syncfusion/ej2-react-navigations';
import Pivot from "./Pivot";
import InvoiceList from "./InvoiceList";


function NewReport() {
    let headertext;
    // Mapping Tab items Header property
    headertext = [
        { text: "Ҳисоботи хулосавӣ", },
        { text: "Фехристи инвойсҳо", },
    ];
    const tabContent1 = () => {
        return (<div>
                <Pivot />
            </div>);
    };
    const tabContent2 = () => {
        return (<div>
                <InvoiceList />
            </div>);
    };
    
    return (<div className='control-pane'>
            <div className='control-section tab-control-section'>
                {/* Render the Tab Component */}
                <TabComponent id='defaultTab'>
                    <TabItemsDirective>
                        <TabItemDirective header={headertext[0]} content={tabContent1}/>
                        <TabItemDirective header={headertext[1]} content={tabContent2}/>
                    </TabItemsDirective>
                </TabComponent>
            </div>
        </div>);
}

export default NewReport;
